import { Templates } from './templates';
import { IRenderer } from '../renderer';
import { FormDescriptor } from '../../../modules/form/model/form';
export class FormRenderer implements IRenderer {
  RenderHeader(preview: any) {
    if (preview as FormDescriptor) {
      const form = preview as FormDescriptor;
      return '<b>' + form.identifier + ' v' + form.version + ' - ' + form.title + '</b>';
    }
    return '<b>invalid databinding</b>';
  }
  RenderBody(preview: any) {
    let html = '<ul class="bulletless">';
    if (preview as FormDescriptor) {
      const form = preview as FormDescriptor;
      if (form.identifier) { html += Templates.listItem('Űrlap Azonosító:', form.identifier); }
      if (form.version) { html += Templates.listItem('Űrlap verzió:', form.version.toString()); }
      if (form.title) { html += Templates.listItem('Űrlap megnevezés:', form.title); }
    }
    html += '</ul>';
    return html;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/preview.service/renderers/form.renderer.ts